import { ErrorViewModel, 
         SessionEntity }                       from '../../..';


export interface IConversationSessionState {
  /** Indicates whether the chatbot widget has a request in progress or not */
  isLoading: boolean;
  /** Indicates whether latest chatbot widget's request is succeed  */
  isRequestSucceed: boolean;
  /** Indicates that the widget parameters has been received or not */
  isWidgetConfigAvailable?: string;
  /** The user session entity instance */
  conversationSession?: SessionEntity;
  /** The emotion to play id when emotions are available */
  emotionToPlayId?: string;
  /** The emotion to play id when emotions are available */
  suggestions?: string[] | undefined;
  /** The latest action error result asssociated to the current state */
  error?: ErrorViewModel;
}

export const ConversationSessionDefaultState = (): IConversationSessionState => {
  return {
    isLoading: false,
    isRequestSucceed: false,
    isWidgetConfigAvailable: undefined,
    conversationSession: undefined,
    emotionToPlayId: undefined,
    suggestions: undefined,
    error: undefined,
  };
};